<template>
	<div class="banner-container">
		<img src="../assets/naic/home/banner.v7.jpg" class="website" />
		<img src="../assets/naic/home/banner.v7.jpg" class="wap" />
	</div>
</template>

<script>
export default {
	name: "banner",
};
</script>

<style scoped lang="scss">
.banner-container {
	// height: 422px;
	text-align: center;
	height: 604px;
	img.website {
		// height: 422px;
		width: 100%;
		height: 604px;
		display: block;
	}
	img.wap {
		// height: 324px;
		display: none;
	}
}
// @media screen and (max-width: 768px) {
// 	.website {
// 		display: none !important;
// 	}
// 	.wap {
// 		display: block !important;
// 		width: 100vw !important;
// 		height: 45vw !important;
// 	}
//   .banner-container {
//     height: 45vw !important;
//   }
// }
</style>
